<script>
import apiServices from '@/services/yungol-services'
export default {
  template: `<div class="buttons is-justify-end" style='width: 100%; height: 100%; margin: auto; margin-top: 2px'>
    <button class="button is-dark" v-on:click="editEmployee()">
        <span v-tooltip="'Editar'" class="icon">
          <i class="material-icons">edit</i>
        </span>
    </button>
    <button class="button is-danger" v-on:click="deleteEmployee()">
        <span v-tooltip="'Eliminar'" class="icon">
          <i class="material-icons">delete_forever</i>
        </span>
    </button>
  </div>`,
  data(){
    return {
      params: this.$parent.params
    }
  },
  props:{
    proceso: Object
  },
  methods:{
    // Actions
    async deleteEmployee(){
      const config = {
        title: '¿Estás seguro?',
        text: "Al eliminar no se podrá recuperar el empleado después.",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#de5b5b',
        confirmButtonText: 'Sí, eliminar'
      };
      await this.$swal(config).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const result = await apiServices.delete(`/deleteoneemployee/${this.proceso._id}/${this.params.value}`);
            if (result.data) {
              await this.$swal({
                text: 'Empleado eliminado correctamente.',
                icon: 'success',
                showConfirmButton: false,
                timer: 1700
              })
              this.params.api.applyTransaction({
                remove: [this.params.node.data],
              });
              this.$emit('getEmployees')
            }
          } catch (err) {
            await this.$swal({
              text: 'Error al eliminar el empleado.',
              icon: 'error',
              showConfirmButton: false,
              timer: 1700
            })
            console.log(err)
          }
        }
      });
    },
    editEmployee(){
      this.$emit('editEmployee', this.params.data)
    },
  }
}
</script>

<style lang='scss'>
.no-border {
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/climan/components/buttonsActionEmployees.vue